import { selectMany } from "../../omnia"
import { getPolygons } from "../../utils"
import Coord = omnia.map.Coord
import IMapTopologyService = omnia.map.IMapTopologyService
import { ol_Coordinate, ol_extent, ol_geom } from "@omnia/exports/openlayers"

export function createGridCells(geometry: ol_geom.Geometry, cellSpec: { width: number, height: number, angle: number, offset: [number, number] }, topo: IMapTopologyService) {

    const measure = topo.measure

    const { angle, offset } = cellSpec
    const anchor = topo.getCentroid(geometry)
    const target = topo.getConvexHull(geometry).getOpenLayersGeometry() as ol_geom.Geometry
    (<any>target).rotate(-angle, anchor)

    const extent = target.getExtent()

    const { width, height } = omnia.map.getExtentDimensions(measure, extent)

    const xratio = ol_extent.getWidth(extent) / width
    const yratio = ol_extent.getHeight(extent) / height

    const cellWidth = cellSpec.width * xratio
    const cellHeight = cellSpec.height * yratio

    const xcells = 1 + Math.ceil(width / cellSpec.width)
    const ycells = 1 + Math.ceil(height / cellSpec.height)

    let xdiff = ((xcells * cellWidth) - ol_extent.getWidth(extent)) / 2
    let ydiff = ((ycells * cellHeight) - ol_extent.getHeight(extent)) / 2

    if (offset) {
        let [x, y] = offset
        x /= xratio || 1
        y /= yratio || 1
        const rx = (x * Math.cos(-angle)) - (y * Math.sin(-angle))
        const ry = (y * Math.cos(-angle)) + (x * Math.sin(-angle))
        xdiff = (rx % cellWidth) + (rx < 0 ? cellWidth : 0)
        ydiff = (ry % cellHeight) + (ry < 0 ? cellHeight : 0)
    }

    let origin = ol_extent.getBottomLeft(extent)

    origin = [
        origin[0] - xdiff,
        origin[1] - ydiff
    ]

    const cells: ol_geom.Polygon[] = []

    for (let ix = 0; ix < xcells; ix++) {

        for (let iy = 0; iy < ycells; iy++) {

            const bl = [origin[0] + (ix * cellWidth), origin[1] + (iy * cellHeight)] as Coord

            const cell = new ol_geom.Polygon([[
                bl,
                [bl[0] + cellWidth, bl[1]],
                [bl[0] + cellWidth, bl[1] + cellHeight],
                [bl[0], bl[1] + cellHeight],
                bl
            ]]);

            cells.push(cell)

        }

    }

    const collection = new ol_geom.GeometryCollection(cells);

    (<any>collection).rotate(cellSpec.angle, anchor)

    const checkIntersection = (coord: ol_Coordinate): boolean => (<any>geometry).intersectsCoordinate(coord)

    const partition = collection.getGeometries().map((cell: ol_geom.Polygon) => ({
        cell,
        inside: cell.getCoordinates()[0].every(checkIntersection)
    }))

    const intersections = selectMany(partition.map(p => {

        if (p.inside) {
            return [p.cell]
        }
        else {
            const i = topo.intersection(geometry, p.cell)
            return i ? getPolygons(i.getOpenLayersGeometry()) : []
        }

    }))

    return intersections

}
